<template>
  <div
    id="goals"
    class="content"
  >
    <div id="content">
      <div class="container">
        <h1 class="page-title">
          <i class="fal fa-calendar-alt"></i> Objectifs Quotidiens
        </h1>
        <div
          class="info-button"
          @click.stop="$parent.toggleInfo"
        >
          <i class="fal fa-info-circle"></i> {{$parent.info_visible ? "Masquer les informations" : "Voir les informations"}} </div>
      </div>
      <div
        class="page-description"
        :class="{hidden: !$parent.info_visible}"
      >
        <b-message type="is-primary">
          <i class="fal fa-info-circle"></i>
          Pour <strong>saisir</strong> un nouvel Objectif Quotidien, cliquez sur "<strong><i class="far fa-plus-circle"></i> Ajouter un Objectif Quotidien"</strong>, puis remplissez la totalité des champs.
          <br>
          Pour <strong>activer</strong> des Objectifs Quotidiens, vous devez au préalable <strong>activer</strong> les Weezys associés.
          <br>
          <strong>L'heure d'activation</strong> des Objectifs Quotidiens, permet d'évaluer le rythme de vente des opérateurs depuis le tableau de bord.
          <br>
          Il est possible de la modifier en cas d'activation de l'Objectif par erreur.
          <br>
          Pour <strong>modifier</strong> les différentes entrées de la liste, sélectionnez un champ puis cliquez sur <strong>"<i class="far fa-check"></i> Valider les modifications"</strong>.
          <br>
          Pour <strong>annuler</strong> les modifications, cliquez sur "<strong><i class="far fa-times"></i> Annuler les modifications"</strong>.
          <br>
          Pour <strong>supprimer</strong> des Objectifs Quotidiens, cochez les lignes puis cliquez sur le bouton <strong>"Supprimer"</strong>.
        </b-message>
      </div>
    </div>
    <goalsTable
      ref="goalsTable"
      id="goalsTable"
      :goals="
                goals"
      :themes="themes"
      :campaigns="campaigns"
      :weezys="weezys"
      :checkable="true"
      :isComponentModalActive="isComponentModalActive"
      :isAdmin="isAdmin"
    />
  </div>
</template>

<script>
/* import components */
import goalsTable from "@/components/goalsTable";

/* Import modules */
import http from "@/modules/request";

export default {
  name: "goals",
  components: {
    goalsTable
  },
  data() {
    return {
      isAddDisplayed: false,
      goals: [],
      themes: [],
      campaigns: [],
      weezys: [],
      goalId: "",
      daily_sales_goal: "",
      creation_date: "",
      creation_time: "",
      is_active: "",
      is_reached: "",
      is_vibe_sensor_active: "",
      sound_volume: "",
      theme_id: "",
      weezy_id: "",
      activation_date_time: "",
      isComponentModalActive: false,
      isDeleteConfirmationModalActive: false,
      isAdmin: [undefined, undefined]
    };
  },
  mounted() {
    this.getCampaigns();
    this.getGoals();
    this.getWeezys();
    this.getThemes();
    this.isAdmin = [
      this.$store.state.role == "admin",
      this.$store.state.weezy_id
    ];
  },
  methods: {
    getGoals() {
      http
        .get("/goals")
        .then(response => {
          var tempGoals = response.data;
          var visibleGoals = [];
          for (var i = 0; i < tempGoals.length; i++) {
            if (!tempGoals[i].is_hidden) {
              visibleGoals.push(tempGoals[i]);
            }
          }
          for (var i = 0; i < visibleGoals.length; i++) {
            //Convert Data to date
            if (visibleGoals[i].activation_date_time != null) {
              visibleGoals[i].activation_date_time = new Date(
                visibleGoals[i].activation_date_time
              );
            }
          }
          this.goals = visibleGoals;
          this.$refs.goalsTable.resetModifiedArray();
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    },
    getWeezys() {
      http
        .get("/weezys")
        .then(response => {
          this.weezys = response.data;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    },
    getThemes() {
      http
        .get("/themes")
        .then(response => {
          this.themes = response.data;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    },
    getCampaigns() {
      http
        .get("/campaigns")
        .then(response => {
          this.campaigns = response.data;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    },
    submitAdd: function() {
      this.creation_date = this.dateFormatter(new Date());
      http
        .post("/goals", {
          goal: {
            creation_date_time: this.creation_date,
            daily_sales_goal: this.daily_sales_goal,
            is_active: this.is_active,
            sound_volume: this.sound_volume,
            theme_id: this.theme_id,
            is_vibe_sensor_active: this.is_vibe_sensor_active,
            weezy_id: this.weezy_id
          }
        })
        .then(
          function(response) {
            this.$refs.goalsTable.isSubmitting = false;
            this.succesToast("Objectif ajouté avec succès");
            this.getGoals();
            this.isComponentModalActive = false;
          }.bind(this)
        )
        .catch(function(error) {
          this.$refs.goalsTable.isSubmitting = false;
          this.errorToast("Échec d'ajout de l'Objectif");
          console.log("error (normal) :" + error);
          console.log("error (as JSON) :" + JSON.stringify(error));
        });
    },
    submitModify: function() {
      var dateTime =
        this.dateFormatter(this.activation_date_time) +
        " " +
        this.timeFormatter(this.activation_date_time);
      http
        .patch("/weezys/" + this.weezy_id + "/goals/" + this.goalId, {
          goal: {
            creation_date_time: this.creation_date_time,
            daily_sales_goal: this.daily_sales_goal,
            is_active: this.is_active,
            sound_volume: this.sound_volume,
            theme_id: this.theme_id,
            is_vibe_sensor_active: this.is_vibe_sensor_active,
            weezy_id: this.weezy_id,
            activation_date_time: dateTime
          }
        })
        .then(
          function(response) {
            this.getGoals();
            this.succesToast("Objectif(s) Modifié(s) avec succès");
          }.bind(this)
        )
        .catch(function(error) {
          this.errorToast("Échec de la modification");
          console.log("error (normal) :" + error);
          console.log("error (as JSON) :" + JSON.stringify(error));
        });
    },
    submitDelete: function() {
      http
        .delete("/goals/" + this.goalId)
        .then(
          function(response) {
            this.getGoals();
            this.succesToast("Objectif(s) supprimé(s) avec succès");
            this.isDeleteConfirmationModalActive = false;
          }.bind(this)
        )
        .catch(function(error) {
          this.errorToast("Échec de suppression");
          console.log("error (normal) :" + error);
          console.log("error (as JSON) :" + JSON.stringify(error));
        });
    },
    clearFields: function() {
      this.goalId = "";
      this.creation_date = "";
      this.creation_time = "";
      this.daily_sales_goal = "";
      this.is_active = "";
      this.is_reached = "";
      this.is_vibe_sensor_active = "";
      this.sound_volume = "";
      this.theme_id = "";
      this.weezy_id = "";
    },
    dateFormatter(value) {
      var date = new Date(value);
      var years = date.getFullYear();
      var months = this.leadZero(date.getMonth() + 1);
      var days = this.leadZero(date.getDate());
      return years + "-" + months + "-" + days;
    },
    timeFormatter(value) {
      var date = new Date(value);
      var hours = this.leadZero(
        date.getHours() + date.getTimezoneOffset() / 60
      );
      var minutes = this.leadZero(date.getMinutes());
      return hours + ":" + minutes;
    },
    leadZero(n) {
      return n > 9 ? n : "0" + n;
    },
    deleteCheckedRows(checkedGoals) {
      var count = checkedGoals.length;
      for (var i = 0; i < count; i++) {
        this.goalId = checkedGoals[i].id;
        this.submitDelete();
      }
    },
    modifyRows(rows) {
      var count = rows.length;
      var modifiedArray = [];
      // From latest to oldest
      for (var i = 0; i < count; i++) {
        var modified = rows[count - i - 1];
        if (!modifiedArray.includes(modified.id)) {
          modifiedArray.push(modified.id);
          this.goalId = modified.id;
          this.daily_sales_goal = modified.daily_sales_goal;
          this.is_active = modified.is_active;
          this.sound_volume = modified.sound_volume;
          this.theme_id = modified.theme_id;
          this.is_vibe_sensor_active = modified.is_vibe_sensor_active;
          this.weezy_id = modified.weezy_id;
          this.activation_date_time = modified.activation_date_time;
          this.submitModify();
        }
      }
    },
    addNewRow(rows) {
      this.daily_sales_goal = rows.daily_sales_goal;
      this.sound_volume = rows.sound_volume;
      this.weezy_id = rows.weezy_id;
      this.theme_id = rows.theme_id;
      this.is_active = rows.is_active;
      this.is_vibe_sensor_active = rows.is_vibe_sensor_active;
      this.submitAdd();
    },
    errorToast(message) {
      this.$toast.open({
        duration: 5000,
        message: message,
        position: "is-bottom",
        type: "is-danger"
      });
    },
    succesToast(message) {
      this.$toast.open({
        duration: 2000,
        message: message,
        position: "is-bottom",
        type: "is-success"
      });
    }
  }
};
</script>

<style scoped>
.content {
  background-color: #ffffff;
}
</style>